import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "footer-list-kulioner",
  class: "absolute bottom-3 w-full border border-red left-0 py-3 px-6 bg-white footer-shadow",
  style: {"z-index":"29"}
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center gap-4" }
const _hoisted_3 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-black font-semibold text-sm" }
const _hoisted_6 = { class: "flex flex-row items-center gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalProcessKulioner = _resolveComponent("ModalProcessKulioner")!
  const _component_ModalSuccessBulkProcessOrder = _resolveComponent("ModalSuccessBulkProcessOrder")!
  const _component_ModalProcessOrder = _resolveComponent("ModalProcessOrder")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (!_ctx.isMerchant)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.totalSelected) + " Pesanan customer terpilih ", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_6, [
          (_ctx.isShowPrintReceipt)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 0,
                id: "button_bulk_print_receipt_list_kulioner",
                title: "Print resi",
                color: "white",
                textColor: "gray-lp-300",
                textSize: "14",
                iconGroupHoverColor: "gray-lp-300",
                iconColor: _ctx.isLoadingModal ? 'gray-lp-600' : 'gray-lp-300',
                customClass: "underline",
                iconLeft: "printer-black",
                sizeIcon: "24px",
                small: "",
                disabled: _ctx.isLoadingPrintReceipt,
                onClick: _ctx.onPrintReceipt
              }, null, 8, ["iconColor", "disabled", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_LpButton, {
            id: "button_bulk_print_order_list_kulioner",
            title: "Download pesanan",
            color: "white",
            textColor: "gray-lp-300",
            customClass: "underline",
            iconGroupHoverColor: "gray-lp-300",
            iconLeft: "download-new",
            iconColor: _ctx.isLoadingModal ? 'gray-lp-600' : 'gray-lp-300',
            sizeIcon: "18px",
            iconV2: "",
            textSize: "14",
            small: "",
            disabled: _ctx.isLoadingModal,
            onClick: _ctx.onPrintOrder
          }, null, 8, ["iconColor", "disabled", "onClick"]),
          (_ctx.status === 'ORDPRC' && !_ctx.isMerchant)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 1,
                title: "Proses semua pengiriman",
                textColor: "white",
                textSize: "12",
                disabled: _ctx.isEligibleProcessOrderByCustomer,
                onClick: _ctx.onProcessOrder
              }, null, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isMerchant)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 2,
                title: "Proses pengiriman",
                textColor: "white",
                textSize: "12",
                disabled: !_ctx.canBeProcessed,
                onClick: _cache[1] || (_cache[1] = () => (_ctx.isShowModalProcess = true))
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (_ctx.isShowAcceptOrder && !_ctx.isMerchant)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 3,
                id: "button_bulk_accept_order_list_kulioner",
                title: _ctx.acceptOrderButtonText,
                textColor: "white",
                textSize: "12",
                onClick: _ctx.onAcceptOrder
              }, null, 8, ["title", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_ModalProcessKulioner, {
      id: "modal-confirm-accept-order",
      modelValue: _ctx.isOpenConfirmOrderModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenConfirmOrderModal = $event)),
      data: _ctx.selected,
      onRefetch: _cache[3] || (_cache[3] = () => _ctx.$emit('refetch')),
      onSuccess: _cache[4] || (_cache[4] = () => (_ctx.isOpenConfirmOrderModal = false)),
      onFailed: _cache[5] || (_cache[5] = () => (_ctx.isOpenConfirmOrderModal = false))
    }, null, 8, ["modelValue", "data"]),
    _createVNode(_component_ModalSuccessBulkProcessOrder, {
      modelValue: _ctx.openModalSuccessBulkProcessOrder,
      "onUpdate:modelValue": [
        _cache[6] || (_cache[6] = ($event: any) => (_ctx.openModalSuccessBulkProcessOrder = $event)),
        _cache[7] || (_cache[7] = () => _ctx.$emit('onSuccesOrder'))
      ],
      data: _ctx.bulkProcessResponse,
      shipmentIds: _ctx.shipmentIds,
      isMerchant: _ctx.isMerchant,
      merchantData: _ctx.merchantData
    }, null, 8, ["modelValue", "data", "shipmentIds", "isMerchant", "merchantData"]),
    _createVNode(_component_ModalProcessOrder, {
      modelValue: _ctx.isShowModalProcess,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowModalProcess = $event)),
      merchants: _ctx.merchantData,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowModalProcess = false)),
      onConfirm: _ctx.onProcessOrder
    }, null, 8, ["modelValue", "merchants", "onConfirm"])
  ], 64))
}